export const getSubjectState = (state: any) => state.subject
